import routerOptions0 from "/usr/src/app/content/n3-spas-9c867eb9-71ed-44ab-97d8-161722bd6448/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}